import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class ReportsService {
  constructor(private http: HttpClient) {}

  public createReport({ type, ...params }): Observable<any> {
    let rate: string

    if (['COMMERCIAL_LICENSE', 'RDN'].includes(type)) {
      rate = 'propertyRates/'
    }

    if (
      [
        'rateBook',
        'businessBook',
        'businessDefaulters',
        'propertyDefaulters',
      ].includes(type)
    ) {
      rate = ''
    }

    const queryString = Object.keys(params)
      .map((key) => key + '=' + params[key])
      .join('&')
    let url = `${environment.API_ENDPOINT}/report/${rate}${type}?${queryString}`

    return this.http.get(url, {
      observe: 'response',
      responseType: 'blob' as 'json',
    })
  }
}
